export default {
  POST_AUTH_SIGN_IN: "/User/Login",
  AUTHENTICATE_SIGNUP: "/User/CreateUser",
  CHECK_INVITE_CODE: "/User/CheckInviteCode",
  LOGIN_SOCIAL: "/User/Login-Social",
  FORGOT_PASSWORD: "/User/forgot",
};
